module.exports = __webpack_public_path__ + "images/nissan77c2a761a8c6f2bb8e7d032cfc4752d0.png";